import * as React from 'react';
import {useSelector} from "react-redux";

export function BomProductNotification() {
    const filter = useSelector((state) => state.entities.ProductListingFilterApplied)
    const selectedCategory = filter && filter.Categories && filter.Categories.selection && filter.Categories.selection[0].value

    const getCategoryText = (category) => {
        if (category !== undefined &&
            category !== '' &&
            filter.Categories.selection[0].hidden_payload !== undefined &&
            filter.Categories.selection[0].hidden_payload !== null &&
            filter.Categories.selection[0].hidden_payload.partNumber !== undefined &&
            filter.Categories.selection[0].hidden_payload.partNumber !== null &&
            filter.Categories.selection[0].hidden_payload.partNumber.trim() !== '') {
            return filter.Categories.selection[0].hidden_payload.partNumber;
        }
        return false;
    };

    return (
        <>
            {getCategoryText(selectedCategory) &&
            <div className="container">
                <div className="alert alert-dark justify-content-center m-b-30">
                    <span>You searched for {getCategoryText(selectedCategory)}, Add to BOM from results below.</span>
                </div>
                <h4>{selectedCategory}</h4>
            </div>
            }
        </>
    );

}
